import React from 'react';
import { useLocation } from 'react-router-dom';

import ModalPage from '../../common/NonConnectedModalPage';
import Spacer from '../../common/Spacer';
import TrTitle, { PageCategories } from '../../common/TrTitle';
import RoundedButton from '../../common/RoundedButton';

import { genLandlordURL } from '../../services/genUrl';
import tr, { site } from '../../localization/translate';

import logo from '../../assets/images/igglo-logo.svg';
import './PasswordChanged.scss';

export default function PasswordChanged() {
  const location = useLocation();
  const nextUrl = location.state?.nextUrl;

  const loginButton = () => {
    // If explicit nextUrl is provided, redirect there.
    if (nextUrl) {
      return (
        <RoundedButton styleName="link_button" rawLink to={nextUrl}>
          { tr('password_changed.go_to_login') }
        </RoundedButton>
      );
    }

    // Otherwise go to login.
    if (site === 'rent') {
      return (
        <RoundedButton styleName="link_button" to="/login">
          { tr('password_changed.go_to_login') }
        </RoundedButton>
      );
    }

    return (
      <RoundedButton styleName="link_button" rawLink to={genLandlordURL('/login')}>
        { tr('password_changed.go_to_login') }
      </RoundedButton>
    );
  };

  return (
    <ModalPage>
      <TrTitle category={PageCategories.EMAIL} name="Password changed" title="password_changed" />

      <img src={logo} alt={tr('common.logo_alt')} styleName="logo" />

      <Spacer />

      <h1 className="title_top watermelon center bottom_margin_36">
        { tr('password_changed.info_header') }
      </h1>

      <p className="text tall_lines dusty_lavender bottom_margin_36">
        { tr('password_changed.continue_text') }
      </p>

      { loginButton() }
    </ModalPage>
  );
}
